<template>
    <div>
        <b-button v-if="!avisadoShow" @click="avisar" variant="outline-primary" class="avisar-btn" :disabled="avisando">
            Avisar para recoger <b-spinner small v-if="avisando"></b-spinner>
        </b-button>
        <b-alert :show="avisadoShow" @dismissed="avisadoShow=false" variant="success" class="alerta" dismissible>
            Hemos recibido el aviso para recoger las cajas y bandejas vacías
        </b-alert>
    </div>
</template>

<script>
export default {
    name: "DevolverBandejas",
    data() {
        return {
            avisando: false,
            avisadoShow: false,
        }
    },
    methods: {
        avisar() {
            this.avisando = true;
            axios.post(this.route('account.devolver-bandejas.devolver')).then(response => {
                this.avisadoShow = true;
            }).catch(err => {
                Vue.toasted.show('Ha ocurrido un error, vuelva a intentarlo más tarde o póngase en contacto con nosotros', {
                    type: "error",
                    duration: 3000
                });
            }).finally(() => {
                this.avisando = false;
            });
        }
    }
}
</script>

<style scoped>
    .avisar-btn {
        color: #0066CC;
        border-color: #0066CC;
        border-width: 2px;
        font-weight: bold;
    }

    .avisar-btn:hover {
        color: #ffffff;
        border-color: #0066CC;
        background-color: #0066CC;
    }

    .alerta {
        border-color: #0066CC;
        background: #ffffff;
        color: #0066CC;
        border-width: 2px;
        font-weight: bold;
    }
</style>
